import {
  BwArchiveAttachment,
  BwImageAttachment,
  BwPdfAttachment,
  BwPptAttachment,
  BwSheetAttachment,
  BwTextAttachment,
  BwVideoAttachment,
  BwWordAttachment,
} from "@/components/ui/icons";

const getIconComponent = (fileExtension: string) => {
  let IconComponent;
  switch (fileExtension) {
    case "docx":
    case "doc":
      IconComponent = BwWordAttachment;
      break;
    case "bmp":
    case "tiff":
      IconComponent = BwImageAttachment;
      break;
    case "mp4":
    case "mov":
    case "avi":
    case "hevc":
    case "mkv":
      IconComponent = BwVideoAttachment;
      break;
    case "pdf":
    case "rtf":
      IconComponent = BwPdfAttachment;
      break;
    case "zip":
    case "gz":
    case "tar":
    case "rar":
      IconComponent = BwArchiveAttachment;
      break;
    case "xls":
    case "csv":
    case "xlsx":
      IconComponent = BwSheetAttachment;
      break;
    case "ppt":
    case "pptx":
      IconComponent = BwPptAttachment;
      break;
    case "txt":
      IconComponent = BwTextAttachment;
      break;
    default:
      IconComponent = BwTextAttachment;
      break;
  }
  return IconComponent;
};

type FileIconProps = {
  fileNameOrExtension: string;
  size?: number;
};

export default function FileIcon({
  fileNameOrExtension,
  size = 24,
}: FileIconProps) {
  const fileExtension =
    fileNameOrExtension.split(".")?.at(-1)?.toLocaleLowerCase() ||
    fileNameOrExtension;

  const IconComponent = getIconComponent(fileExtension);

  return <IconComponent size={size} />;
}
